/* eslint-disable no-param-reassign */
export const addPropertyToItems = (items, typeObjs) => {
  items.forEach(itm => {
    typeObjs.forEach(typeObj => {
      if (Array.isArray(typeObj.value)) {
        let result = '';
        typeObj.value.forEach(val => {
          result = `${result} ${itm[val]}`;
        });
        itm[typeObj.name] = result;
      } else {
        itm[typeObj.name] = typeObj.value;
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/SearchResultGrid/helpers.js